module.exports = __webpack_public_path__ + "static/media/new1@2x.d32d1573.png";